
export type Roles = 'account_admin' | 'admin' | 'user' | 'assistant'
export const isAdmin = (role: Roles) => role === 'admin' || role === 'account_admin';